import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {routeAnimation} from '../../../../route.animation';
import {FormBuilder, Validators} from '@angular/forms';
import {FormsService} from '../../../../_services/forms.service';
import {ActivatedRoute, Params} from '@angular/router';
import {PreviousUrlService} from '../../../../_services/previous-url.service';
import {Subscription} from 'rxjs/Subscription';
import {ReportsService} from '../../../../_services/reports.service';
import {Reports} from '../../../../_interfaces/reports/reports';
import {PageTitleService} from '../../../../_services/page-title.service';
import {environment} from '../../../../../environments/environment';

@Component({
	selector: 'app-reports-attachments-create',
	templateUrl: './reports-attachments-create.component.html',
	styleUrls: ['./reports-attachments-create.component.scss'],
	animations: [routeAnimation]
})

export class ReportsAttachmentsCreateComponent implements OnInit, OnDestroy {

	@HostBinding('@routeAnimation') routerTransition = true;

	public report_id: number = null;

	public reportAttachmentsCreateForm = this.formBuilder.group({
		filename: ['', Validators.required],
		title: ['', [Validators.required, Validators.maxLength(100)]],
		description: ['']
	});

	private _activatedRouteSubscription: Subscription = null;
	private _errorsSubscription: Subscription = null;

	constructor(public reportsService: ReportsService,
				public formsService: FormsService,
				private activatedRoute: ActivatedRoute,
				private formBuilder: FormBuilder,
				private previousUrlService: PreviousUrlService,
				private pageTitleService: PageTitleService) {
	}

	ngOnInit(): void {
		this.formsService.form = this.reportAttachmentsCreateForm;

		this._errorsSubscription = this.reportsService.errors.subscribe(errors => {
			this.formsService.processErrors(errors);
		});

		this._activatedRouteSubscription = this.activatedRoute.params.subscribe((params: Params) => {
			this.report_id = parseInt(params['report_id'], 10);

			this.reportsService.getReport(this.report_id).then((report: Reports) => {
				if (typeof report !== 'undefined') {

					this.pageTitleService.setTitle(report.report_nr + ' | Rapportage bijlage toevoegen | ' + environment.webappName);
					this.pageTitleService.setPageTitle(report.report_nr);
				}
			});

			this.previousUrlService.setPreviousUrlIfNull('reports/' + this.report_id + '/view');
		});

	}

	ngOnDestroy(): void {
		if (this._activatedRouteSubscription !== null) {
			this._activatedRouteSubscription.unsubscribe();
		}

		if (this._errorsSubscription !== null) {
			this._errorsSubscription.unsubscribe();
		}
	}
}
